import { HttpInterceptorFn } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BYPASS_INTERCEPTOR } from '@shared/constants/http-context-tokens';

export const TokensInterceptor: HttpInterceptorFn = (req, next) => {
	const cookieService = inject(CookieService);

	if (req.context.get(BYPASS_INTERCEPTOR)) {
		return next(req);
	}

	const isExcluded =
		req.url.includes('/api/v1/auth/*') ||
		req.url.startsWith('https://s3.us-east-2.amazonaws.com/') ||
		req.url.includes('api.apis.net.pe') ||
		req.url.startsWith('https://api.apis.net.pe') ||
		req.url.includes('assets/archivo.html') ||
		req.url.startsWith('/assets/') ||
		req.url.startsWith(window.location.origin + '/assets/');

	if (isExcluded) {
		return next(req);
	}

	const gatewayBase = environment.URL_GATEWAY.replace(/\/api\/v\d+$/, '');

	let gatewayUrl = req.url;
	const matchVersioned = req.url.match(/^\/api\/v(\d+)(.*)$/);
	if (matchVersioned) {
		gatewayUrl = `${gatewayBase}/api/v${matchVersioned[1]}${matchVersioned[2]}`;
	} else if (req.url.startsWith('/api/') && !req.url.startsWith('/api/v')) {
		gatewayUrl = `${gatewayBase}${req.url}`;
	}

	const authData = cookieService.get('authData');
	let token: string | null = null;

	if (authData) {
		try {
			token = JSON.parse(authData)?.access_token ?? null;
		} catch {
			token = null;
		}
	}

	if (token) {
		const clonedRequest = req.clone({
			url: gatewayUrl,
			setHeaders: {
				Authorization: `Bearer ${token}`
			}
		});
		return next(clonedRequest);
	}

	return next(req.clone({ url: gatewayUrl }));
};
